import { suratSeminar, suratBuktiPenyerahanSkripsi, suratUndanganUjianSkripsi, suratAlumni} from '../config/lettersId'
import moment from 'moment'

require('moment/locale/id')
moment.locale('id')

export const displayDate = (letters_fields, letter) => {    
    const dateFields = letters_fields.filter(field => field.name.includes('tanggal') || field.name.includes('tgl'))
 
        letter.fields_value = letter.fields_value.map(val => {     
       
            for(var i in dateFields){ 
               
                if(dateFields[i]._id === val.field_id){
        
                    let tanggal = moment(val.value).format('DD-MM-YYYY')
                    if(tanggal !== 'Invalid date'){
                        switch(letter.letters_id) {            
                            case suratSeminar :
                            case suratBuktiPenyerahanSkripsi:
                            case suratUndanganUjianSkripsi: 
                            case suratAlumni:
                                tanggal =moment(val.value).format('dddd, DD-MM-YYYY')
                                break;
                            default:
                        }                                              
                    }else {
                        tanggal = val.value
                    }
                    return {
                        ...val,
                        value: tanggal
                    }
                }
            }      
          
            return val
        })

        return letter
    
}